import React, { Component } from "react"
import "./TemplatesMenuModal.css"
import { getTranslation } from "../../assets/creator/translations"
import { getAllTemplates, getThumbnail } from "../../templates/_templatesMap"
import { linksGenerator } from "../../utils/welcomeModalsUtils"

class TemplatesMenuModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			onLoadNew: this.props.onLoadNew,
			onLoadProject: this.props.onLoadProject,
			isSelected: null,
			templates: getAllTemplates(),
			templateSettings: false,
			templateSettingsTheme: false,
			isNewProject: false
		}
	}

	toggleSelection = id => {
		this.setState({ isSelected: id })
	}

	handleSelectConfirmButtonClick = async () => {
		if(this.state.isNewProject) {
			this.props.onLoadNew();
		} else if (!this.state.templateSettings) {
			const link = await linksGenerator();
			const b2bCreatorLink = link.b2b + "?template=" + this.state.isSelected + `&lang=${this.props.lang}`;
			window.location.href = b2bCreatorLink;
			return;
		} else {
			this.props.onLoadProject(this.state.templateSettings, this.state.templateSettingsTheme);
		}
		this.setState({ isSelected: false });
	}

	handleSelectTemplateButtonClick = (isNewProject, templateId, templateSettings) => {
		if(isNewProject !== null && isNewProject !== undefined){
			this.toggleSelection(templateId);
			this.setState({ isNewProject: isNewProject });
			if (!templateSettings && !isNewProject) {
				return;
			}
			if(!isNewProject) {
				this.setState({ templateSettings: templateSettings });
				this.setState({ templateSettingsTheme: templateSettings.theme });
			}
		}
	}

	getNewProjectButtonClass = () => {
		if (this.state.isSelected === -1) {
			return "btnNewProject overlay_active";
		}
		return "btnNewProject ";
	};

	getMenuItemImageClass = (templateId) => {
		const base = "templates-menu-modal__menu-item-image";
		if (this.state.isSelected === templateId) {
			return base + " overlay_active";
		}
		return base;
	};

	getMenuItemTextClass = (templateId) => {
		if (this.state.isSelected === templateId) {
			return "text_active";
		}
		return "";
	};

	render() {
		if (this.props.show) {
			return (
				<div className='templates-menu-modal'>
					<div className='templates-menu-modal__wrapper'>
						<p className='templates-menu-modal__header'>
							{getTranslation("SelectTemplateEdition")}
						</p>
						<div className='templates-menu-modal__menu'>
							<div className='newProject'>
								<button
									className={this.getNewProjectButtonClass()}
									onClick={() => this.handleSelectTemplateButtonClick(true, -1)}
								>
									<img
										className='plus__circle__img'
										src='./img/plus-circle.svg'
										alt=''
									/>
								</button>
								<div>
									<p>{getTranslation("NewTemplate")}</p>
								</div>
							</div>
							{this.state.templates.map(template => (
								<React.Fragment key={template.id}>
									<div
										className="templates-menu-modal__menu-item"
										onClick={() => {
											let templateSettings = null;
											if (template.settings) {
												templateSettings = template.settings;
											}
											this.handleSelectTemplateButtonClick(false, template.id, templateSettings);
										}}
									>
										{template.newFlag && (
											<div className="templates-menu-modal__menu-item-flag">
												{getTranslation("NewTemplate")}
											</div>
										)}
										<div
											className={this.getMenuItemImageClass(template.id)}>
											<img src={getThumbnail(template.id)} alt='template_icon'></img>
										</div>
										<div className="templates-menu-modal__menu-item-name">
											<p className={this.getMenuItemTextClass(template.id)}>{getTranslation(template.templateDisplayName)}</p>
										</div>
									</div>
								</React.Fragment>
							))}
						</div>
						<div className='templates-menu-modal__btn-group'>
							<p className='templates-menu-modal__btn-group--link continueEditProjectBtn' onClick={this.props.onReturn}>
								{getTranslation("Btn_Return")}
							</p>
							<button
								className='templates-menu-modal__btn-group--btn templates-menu-modal__btn-group--btn--active templates-menu-modal__btn-group--chooseBtn'
								onClick={this.handleSelectConfirmButtonClick}>
								{getTranslation("Btn_Confirm")}
							</button>
						</div>
						<span className="templates-menu-modal__border-line"></span>
					</div>
				</div>
			)
		} else {
			return null;
		}
	}
}

export default TemplatesMenuModal
